export default [
  {
    path: "/blog/:slug",
    name: "single-blog",
    component: () => import("../CMSPage.vue")
  }
];
